import Address from './Address.vue';

export default Address;
